module.exports = require("xml");